<template>
    <div class="user">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Usuários" sub="" />
            <b-button v-show="!modalActive" id="btn-principal" variant="success" @click="addUser()" size="xg" class="mb-2">    
                <i class="fa fa-plus"></i> Adicionar
            </b-button>
        </div>

        <div id="pageGrid" v-show="!modalActive">
            <b-table :items="users" :fields="fields"
                responsive 
                borderless
                striped
                medium>
                <template slot="nome"  slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nome }}</span>
                    <br>
                    <span style="font-size: smaller;">
                        {{ data.item.email }}
                    </span>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="primary" @click="loadUser(data.item)" size="sm mr-2">  
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button variant="danger" @click="removeUser(data.item)" size="sm">    
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <b-pagination class="customPagination mt-4" size="md" v-model="page" :total-rows="count" :per-page="limit" />
        </div>
        
        <b-modal ref="modalRemove" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente excluir este usuário?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="danger" class="mr-2"
                            @click="confirmeRemove()">Excluir 
                        </b-button>
                        <b-button class="mr-2"
                            @click="hideRemove()">Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>        

        <div id="pageEdition" v-show="modalActive">
            <b-card :header="tituloModal" class="mb-5"> 

                <b-form @submit.prevent="submit">
                    <div class="title-emp">
                        <p>Dados do Usuário</p>
                    </div>

                    <input id="user-id" type="hidden" v-model="user.usuario_id"> 

                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Nome" label-for="user-nome">
                                <b-form-input 
                                    type="text" 
                                    id="user-nome" 
                                    name="user-nome"
                                    ref="user-nome"
                                    v-focus
                                    v-model.trim="user.nome" 
                                    :class="{ 'form-control is-invalid' : $v.user.nome.$error }"
                                    maxlength="100"
                                    placeholder="Informe o nome do usuário">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="8" sm="12">
                            <b-form-group label="*E-mail" label-for="user-email">
                                <b-form-input 
                                    type="text"
                                    id="user-email" 
                                    name="user-email" 
                                    ref="user-email" 
                                    v-model.trim="user.email" 
                                    :class="{ 'form-control is-invalid' : $v.user.email.$error }"
                                    maxlength="50" 
                                    placeholder="Informe o e-mail">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="10" sm="12">
                            <b-form-group label="*Empresa Principal (Registro) " label-for="user-empresa_id">
                                <b-form-select 
                                    id="user-empresa_id"
                                    name="user-empresa_id"
                                    ref="user-empresa_id"
                                    :options="companies" v-model.trim="user.empresa_id"
                                    :class="{ 'form-control is-invalid' : $v.user.empresa_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Status" label-for="user-fl_status">
                                <b-form-select 
                                    id="user-fl_status"
                                    name="user-fl_status"
                                    ref="user-fl_status"
                                    v-model.trim="user.fl_status" :options="optStatus"
                                    :class="{ 'form-control is-invalid' : $v.user.fl_status.$error }">                                    
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>

                    <div class="title-emp">
                        <p>Empresas Visíveis do Usuário</p>
                    </div>

                    <b-row v-for="companyUser in companiesUser" :key="companyUser.empresa_id">
                        <b-col sm="12">
                            <i class="custom-control custom-switch" @click="companyUser.checado = !companyUser.checado">
                                <input type="checkbox" class="custom-control-input" v-model="companyUser.checado">
                                <label class="custom-control-label" for="customSwitches"> {{ companyUser.nm_empresa }} </label>
                            </i>
                        </b-col>
                    </b-row>
                   
                    <br>
                    <br>

                    <div class="title-emp">
                        <p>Permissões de Acesso</p>
                    </div>

                    <b-row>
                        <b-col sm="12">
                            <strong>Dashboard:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_dash_visualizar = !user.fl_dash_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_dash_visualizar" >
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                    </b-row>

                    <br>

                    <b-row>
                        <b-col sm="12">
                            <strong>Empresas:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_emp_visualizar = !user.fl_emp_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_emp_visualizar">
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_emp_adicionar = !user.fl_emp_adicionar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_emp_adicionar">
                                <label class="custom-control-label" for="customSwitches"> Adicionar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_emp_editar = !user.fl_emp_editar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_emp_editar">
                                <label class="custom-control-label" for="customSwitches"> Editar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_emp_excluir = !user.fl_emp_excluir">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_emp_excluir">
                                <label class="custom-control-label" for="customSwitches"> Excluir </label>
                            </i>
                        </b-col>
                    </b-row>
    
                    <br>
                    <b-row>
                        <b-col sm="12">
                            <strong>Plano:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_pla_visualizar = !user.fl_pla_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_pla_visualizar">
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_pla_editar = !user.fl_pla_editar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_pla_editar">
                                <label class="custom-control-label" for="customSwitches"> Editar </label>
                            </i>
                        </b-col>
                    </b-row>

                    <br>

                    <b-row>
                        <b-col sm="12">
                            <strong>Integrações:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_int_visualizar = !user.fl_int_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_int_visualizar">
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_int_adicionar = !user.fl_int_adicionar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_int_adicionar">
                                <label class="custom-control-label" for="customSwitches"> Adicionar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_int_editar = !user.fl_int_editar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_int_editar">
                                <label class="custom-control-label" for="customSwitches"> Editar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_int_excluir = !user.fl_int_excluir">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_int_excluir">
                                <label class="custom-control-label" for="customSwitches"> Excluir </label>
                            </i>
                        </b-col>
                    </b-row>
        
                    <br>

                    <b-row>
                        <b-col sm="12">
                            <strong>Produtos:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_pro_visualizar = !user.fl_pro_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_pro_visualizar">
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_pro_adicionar = !user.fl_pro_adicionar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_pro_adicionar">
                                <label class="custom-control-label" for="customSwitches"> Adicionar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_pro_editar = !user.fl_pro_editar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_pro_editar">
                                <label class="custom-control-label" for="customSwitches"> Editar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_pro_excluir = !user.fl_pro_excluir">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_pro_excluir">
                                <label class="custom-control-label" for="customSwitches"> Excluir </label>
                            </i>
                        </b-col>
                    </b-row>

                    <br>

                    <b-row>
                        <b-col sm="12">
                            <strong>NFS-e:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_nfse_visualizar = !user.fl_nfse_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_nfse_visualizar">
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_nfse_adicionar = !user.fl_nfse_adicionar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_nfse_adicionar">
                                <label class="custom-control-label" for="customSwitches"> Adicionar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_nfse_editar = !user.fl_nfse_editar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_nfse_editar">
                                <label class="custom-control-label" for="customSwitches"> Editar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_nfse_excluir = !user.fl_nfse_excluir">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_nfse_excluir">
                                <label class="custom-control-label" for="customSwitches"> Excluir </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_nfse_download = !user.fl_nfse_download">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_nfse_download">
                                <label class="custom-control-label" for="customSwitches"> Downloads </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_nfse_email = !user.fl_nfse_email">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_nfse_email">
                                <label class="custom-control-label" for="customSwitches"> Enviar E-mail </label>
                            </i>
                        </b-col>
                    </b-row>

                    <br>

                    <b-row>
                        <b-col sm="12">
                            <strong>Importação:</strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_imp_visualizar = !user.fl_imp_visualizar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_imp_visualizar">
                                <label class="custom-control-label" for="customSwitches"> Visualizar </label>
                            </i>
                        </b-col>
                        <b-col md="2" sm="12">
                            <i class="custom-control custom-switch" @click="user.fl_imp_adicionar = !user.fl_imp_adicionar">
                                <input type="checkbox" class="custom-control-input" v-model="user.fl_imp_adicionar">
                                <label class="custom-control-label" for="customSwitches"> Adicionar </label>
                            </i>
                        </b-col>
                        <br>
                        <br>
                        <br>
                    </b-row>

                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModal">Cancelar
                        </b-button>
                        <b-button  id="btn-principal" variant="success" class="mr-2" style="width: 150px;"
                            @click="saveUser">Salvar 
                        </b-button>
                    </div>

                </b-form>        
            </b-card>
        </div>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'
import { required, email } from "vuelidate/lib/validators";
import formMixin from '../../config/mixinform';

export default {
    name: 'Users',

    components: { PageTitle, Modal },

    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            tituloModal: null,
            
            user: {},            
            users: [],            
            companies: [],            
            companiesUser: [],

            fields: [
                { key: 'nome', label: 'Nome' },
                { key: 'nm_empresa', label: 'Empresa' },
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Ações', class: 'text-center' }
            ],
            page: 1,
            count: 0,
            limit: 0,

            optStatus: [
                { value: "A", text: 'Ativo' },
                { value: "I", text: 'Inativo' }
            ]
           
        }
    },

    validations: {
        user: {
            nome: { required },
            empresa_id: { required },
            email: { required, email },
            fl_status: { required }
        }
    },

    methods: {
        loadUsers() {
            axios.get(`${baseApiUrl}/usuario/registro/${this.$store.state.user.register}/pagina/${this.page}`) 
                 .then(resp => {
                     this.users = resp.data.data
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)
            })
        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresasadm/` + this.$store.state.user.userid)  
                 .then(resp => {
                     this.companies = resp.data.data.map(campany => {
                         return { value: campany.empresa_id, text: campany.nm_empresa }
                     })
            })
        },

        loadUser(user, mode = 'save') {
            this.mode = mode
            this.user = { ...user } 

            axios.get(`${baseApiUrl}/usuario/usuario/${user.usuario_id}/usuarioadm/${this.$store.state.user.userid}`)
                .then(resp => {
                    this.user = resp.data.data,
                    this.companiesUser = resp.data.empresasusuario
            })

            this.tituloModal = 'Editar Usuário'
            this.toggleModal()
        },

        addUser() {
            this.user = {}

            // Carrega empresas do user adm para servir ref. na checagem para novos users, que por padrao eh enviado como "0"
            axios.get(`${baseApiUrl}/usuario/usuario/0/usuarioadm/${this.$store.state.user.userid}`)
                .then(resp => {
                    this.user = resp.data.data,
                    this.companiesUser = resp.data.empresasusuario
            })
            //console.log("user ADD = \n" + JSON.stringify(this.user, null, 4))

            this.tituloModal = 'Adicionar Usuário'
            this.toggleModal()
        },

        toggleModal() {
            this.modalActive = !this.modalActive;

            // Redefinir erros de validação de formulário
            this.$v.$reset();            
		},

        reset() {
            this.mode = 'save'
            this.user = {}
            this.companiesUser = []
            this.loadUsers()
        },

        saveUser() {
            // Validacao dos campos do form se for inválido interrompe o envio para API!
            if (this.validate()) {
                // Se tudo ok, prossegue enviando para API!
                const method = this.user.usuario_id ? 'put' : 'post'
                const id = this.user.usuario_id ? `/${this.user.usuario_id}` : ''
                const registro = this.user.usuario_id ? '' : `/registro/${this.$store.state.user.regid}`
            
                // Concatena no objeto do usuario o array das empresas permitidas para enviar em um unico pacote
                var empresasUser = {
                    empresasusuario: this.companiesUser
                }
                var objUser = Object.assign({}, this.user, empresasUser);

                axios[method](`${baseApiUrl}/usuario${id}${registro}`, objUser)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)

                this.toggleModal()
            }
       },
 
        removeUser(user) {
            this.user = { ...user } 
            this.$refs.modalRemove.show(user);
        },

        hideRemove() { 
            this.$refs.modalRemove.hide();
        },

        confirmeRemove() { 
            this.hideRemove();

            const id = this.user.usuario_id
            axios.delete(`${baseApiUrl}/usuario/${id}`)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()
                     this.reset()
                 })
                 .catch(showError)
        }
    },

    watch: {
        page() {
            this.loadUsers()
        }
    },

    mounted() {
        this.loadUsers()
        this.loadCompanies() 
    }
}
</script>

<style scoped>    
    .title-emp {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
</style>